import * as React from 'react';
import {CreateBreadcrumb, IState} from "./Data";
import {RouteComponentProps} from "react-router";
import {CreateLayout} from "../../layout/CreateLayout";
import {SportModel} from "../../model";
import {SportForm} from "./form/SportForm";

export class SportCreate extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      sport: {} as SportModel
    }
  }

  render() {
    return (
        <CreateLayout breadcrumb={CreateBreadcrumb} title={'Add new sport'}>
          <SportForm {...this.state}/>
        </CreateLayout>
    )
  }
}